import React, { useRef, useState } from "react";
import { Image } from "react-bootstrap";
import { useSwitchNetwork } from "wagmi";
import { AnimatePresence, easeInOut, motion } from "framer-motion";

import { envChains } from "utils/helper";
import { MyButton } from "components/button";
import { useRootContext } from "context/app-context";
import { useOutsideClickHook } from "hooks/useOutsideClick";

import polygonIcon from "assets/images/polygonIcon.svg";

const NetworkDropdown = () => {
  const netDropdownRef = useRef(null);
  const [netDropdown, setNetDropdown] = useState(false);

  const { switchNetwork, chains } = useSwitchNetwork();

  const { selectedNetwork } = useRootContext();

  useOutsideClickHook(netDropdownRef, () => setNetDropdown(false));

  return (
    <div ref={netDropdownRef} className="networkDropdown customDropdown">
      <>
        {!envChains?.includes(selectedNetwork) ? (
          <MyButton
            text="Choose Network"
            className="custom-btn md dim-border icon-btn rounded"
            handleClick={() => setNetDropdown(!netDropdown)}
            arrowIcon={process.env.REACT_APP_S3_IMAGE_PATH + "arrowLight.svg"}
          />
        ) : (
          <MyButton
            text={selectedNetwork === envChains[0] ? "Polygon" : "Ethereum"}
            className="custom-btn md dim-border icon-btn rounded"
            handleClick={() => setNetDropdown(!netDropdown)}
            iconButtonImage={
              selectedNetwork === envChains[1]
                ? process.env.REACT_APP_S3_IMAGE_PATH + "ethIcon.svg"
                : polygonIcon
            }
            arrowIcon={process.env.REACT_APP_S3_IMAGE_PATH + "arrowLight.svg"}
          />
        )}
      </>
      <AnimatePresence>
        {netDropdown && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35, ease: easeInOut }}
            className="chooseNet innerDropdown"
          >
            <ul className="mb-0">
              {chains?.map((x) => (
                <li
                  className="d-flex"
                  key={x.id}
                  onClick={() => {
                    switchNetwork?.(x.id)
                    setNetDropdown(false)
                  }}
                  // style={{
                  //   pointerEvents:
                  //     !switchNetwork || x.id === selectedNetwork ? "none" : "auto",
                  // }}
                >
                  <span className="icon">
                    <Image
                      src={
                        x.id === envChains[1]
                          ? process.env.REACT_APP_S3_IMAGE_PATH + "ethIcon.svg"
                          : polygonIcon
                      }
                      fluid
                    />
                  </span>
                  <span className="name">
                    {x.id === envChains[0] ? "Polygon" : "Ethereum"}
                  </span>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NetworkDropdown;
